module.exports = __webpack_public_path__ + "h5/img/noCoupon.e524084b.png";